export default __webpack_public_path__ + "static/media/flv9.1231bc01.jpeg";